class WishlistRemoveList extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.removeList = this.removeList.bind(this)
    this.listeners.add(this, 'click', this.removeList)
  }

  async removeList (e) {
    e.preventDefault()

    window.BAO.wishlist.genericModalHeading = this.modalHeading
    window.BAO.wishlist.genericModalText = this.modalText
    window.BAO.wishlist.genericModalCancelText = this.modalCancelText
    window.BAO.wishlist.genericModalContinueText = this.modalContinueText
    window.BAO.wishlist.openGenericModal()

    window.BAO.wishlist.genericModalContinue = async () => {
      await window.BAO.wishlist.removeList(this.listId, this.token)

      window.location.href = window.theme.appSettings.proxyUrl
    }
  }

  get listId () {
    return this.dataset.listId
  }

  get token () {
    return window.BAO.wishlist.token
  }

  get modalHeading () {
    return this.dataset.modalHeading
  }

  get modalText () {
    return this.dataset.modalText
  }

  get modalCancelText () {
    return this.dataset.modalCancelText
  }

  get modalContinueText () {
    return this.dataset.modalContinueText
  }
}

customElements.define('wishlist-remove-list', WishlistRemoveList)
